import { createStore } from 'easy-peasy'
import { model } from './models'
export * from './hooks'
// export * from './hooks';

export const store = createStore(model)
